<div class="pages">
  <app-create-password *ngIf="finishLoad === 'success'"></app-create-password>
  <div class="poppins page-error" *ngIf="finishLoad === 'error'">
    <span class="title-er" translate>
      components.helpers.¡Ups! Lamentamos las molestias...
    </span>
    <span class="sub-title-er">{{ messageError }}</span>
    <button class="btn-blue" (click)="gotoHome()" translate>
      components.helpers.Ir a la Home
    </button>
  </div>
</div>
